import { ContactsOutlined, DownOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Descriptions,
  Divider,
  Dropdown,
  Form,
  Input,
  InputNumber,
  Menu,
  Modal,
  Popover,
  Row,
  Select,
  Spin,
  Statistic,
  Typography,
  message,
  Checkbox,
  Alert,
  Space,
  Collapse,
} from "antd";
import { React, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { useTransactionHandlers } from "../../bc-client/useTransactionHandlers";
import { createAssetsAction } from "../../constants/actionNames";
import { useGetOrgQuery } from "../../store/auth/orgapi";
import {
  assetApi,
  useAddAssetMutation,
  useAddDocumentToAssetMutation,
  useUpdateAssetMutation,
  useUpdateAssetStatusMutation,
} from "../../store/is/assetapi";
import { useAddAssignmentMutation } from "../../store/is/assignmentapi";
import { useGetProjectQuery } from "../../store/is/projectapi.js";
import { setAsset } from "../../store/is/isSlice";
import {
  useDeleteParamsMutation,
  useGetParamQuery,
} from "../../store/is/paramsapi";
import {
  useGetValidationQuery,
  validationApi,
} from "../../store/is/validationapi.js";
import { yieldApi } from "../../store/is/yieldapi";
import { DisplayDateTime } from "../Utils/DisplayDateTime";
import { DisplayUserName } from "../Utils/DisplayUserName";
import { DisplayOrganization } from "../Utils/DisplayOrganization";
import AddDocument from "./AddDocument";
import DisplayDocuments from "./DisplayDocuments";
import Params from "./Params.js";
import AssignVerifier from "./Utils/AssignVerifier";
import { DisplayIntervention } from "./Utils/DisplayIntervention";
import { ParamView } from "./Utils/ParamView";
import PerformOperationaCheckOnAsset from "./Utils/PerformOperationaCheckOnAsset.js";
import PerformValidationOnAsset from "./Utils/PerformValidationOnAsset.js";
import ViewDownloadCertificate from "./ViewDownloadCertificate.js";
import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";
import Yield from "./Yield";
import store from "../../store/store.js";

const statusOptions = [
  { value: "New", label: "New" },
  { value: "Proba Review", label: "Proba Review" },
  { value: "Public Consultation", label: "Public Consultation" },
  { value: "Validator Review", label: "Validator Review" },
  { value: "Revision", label: "Revision" },
  { value: "Active", label: "Active" },
  { value: "Inactive", label: "Inactive" },
  { value: "Verified Quality", label: "Verified Quality" },
  { value: "Verified Quantity", label: "Verified Quantity" },
  { value: "verified", label: "Verified" },
  { value: "Reserved", label: "Reserved" },
  { value: "InClaim", label: "In Claim" },
  { value: "Booked", label: "Booked" },
  { value: "ProvDeleted", label: "Prov Deleted" },
  { value: "Invisible", label: "Invisible" },
  { value: "Final", label: "Final" },
];

const ASSET_TYPE_OPTIONS = [
  { value: "generic", label: "Generic Asset" },
  { value: "land_management_unit", label: "Land Management Unit" },
];

const PLOT_SIZE_UNIT_OPTIONS = [
  { value: "ha", label: "Hectares (ha)" },
  { value: "acres", label: "Acres" },
];

const DEFAULT_ASSET_TYPE = ASSET_TYPE_OPTIONS[0].value;

const normalizeAssetPayload = (values = {}) => {
  const type = values.type || DEFAULT_ASSET_TYPE;
  const normalized = {
    ...values,
    type,
  };

  if (type === "land_management_unit") {
    normalized.plot_size =
      typeof values.plot_size === "number" ? values.plot_size : null;
    normalized.plot_size_unit = values.plot_size_unit || "ha";
    normalized.soil = values.soil || null;
  } else {
    normalized.plot_size = null;
    normalized.plot_size_unit = null;
    normalized.soil = null;
  }

  return normalized;
};

function AddEditAsset() {
  const [spinning, setSpinning] = useState(false);
  const [updateAssetStatus] = useUpdateAssetStatusMutation();

  let userid = useSelector((state) => state.auth.userid);
  let usergroup = useSelector((state) =>
    state.auth.groups?.map((group) => group?.name)
  );
  const orgId = useSelector((state) => state.auth?.org?._id);

  usergroup = usergroup.filter(Boolean);

  let { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  let asset = useSelector((state) => state.is.asset);
  let project = useSelector((state) => state.is.intervention);

  if (id !== "add" && !project?.name) {
    history.push({
      pathname: `/intervention/list`,
    });
  }
  if (id !== "add" && !asset?.name) {
    history.push({
      pathname: `/intervention/list`,
    });
  }
  const [isEditing, setIsEditing] = useState(id === "edit" ? true : false);
  const [isCreate, setIsCreate] = useState(id === "add" ? true : false);
  const [editingRecord, setEditingRecord] = useState(asset);
  const [isView, setIsView] = useState(id === "view" ? true : false);
  const [isAssetSignOff, setIsAssetSignOff] = useState(false);

  const [addAsset, { isCreateLoading }] = useAddAssetMutation();
  const [updateAsset, { isUpdateLoading }] = useUpdateAssetMutation();
  const [deleteParam] = useDeleteParamsMutation();

  const [addAssetDocument] = useAddDocumentToAssetMutation();
  const { data: organizationData, isLoading } = useGetOrgQuery(
    project?.organization,
    { skip: !project?.organization }
  );
  const {
    data: validationsData,
    refetch: refetchValidation,
  } = useGetValidationQuery(project?._id);

  const [isCreateParam, setIsCreateParam] = useState(false);
  const [isEditParam, setIsEditParam] = useState(false);
  const [editParamRecord, setEditParamRecord] = useState(null);
  const [paramId, setParamId] = useState(null);
  const [isAssetFreeze, setAssetFreeze] = useState(
    asset?.lock_status == "lock" ? true : false
  );

  const [isCreateDocument, setIsCreateDocument] = useState(false);
  const [isEditDocument, setIsEditDocument] = useState(false);
  const [editDocumentRecord, setEditDocumentRecord] = useState(null);
  const [isAssetHasAssignment, setIsAssetHasAssignment] = useState(false);

  const [isAssetVerified, setIsAssetVerified] = useState(false);

  const [isInterventionVerified, setIsInterventionVerified] = useState(false);
  const [addDocumentBtnDisabled, setAddDocumentBtnDisabled] = useState(false);
  const [addParamBtnDisabled, setAddParamBtnDisabled] = useState(false);
  const [isIntervHasAssignment, setIsIntervHasAssignment] = useState(false);
  const [isCreateAssigneeToAsset, setIsCreateAssigneeToAsset] = useState(false);
  const [isassignUserToAsset, setIsassignUserToAsset] = useState(null);
  const [openProbaReviewModal, setOpenProbaReviewModal] = useState(false);
  const [validationData, setValidationData] = useState(null);
  const [isValidationLoading, setIsValidationLoading] = useState(false);

  const [isSubmitForProbaReview, setIsSubmitForProbaReview] = useState(false);
  const [isProjectStsProbaReview, setIsProjectStsProbaReview] = useState(false);
  const [isProjectStsRevision, setIsProjectStsRevision] = useState(false);
  const [
    confirmLoadingProbaReviewModal,
    setConfirmLoadingProbaReviewModal,
  ] = useState(false);

  const [isIntervStsActive, setIntervStsActive] = useState(
    project?.status === "Active"
  );

  const [isAssetStsNew, setAssetStsNew] = useState(asset?.status === "New");
  const [isAssetStsRevision, setAssetStsRevision] = useState(
    asset?.status === "Revision"
  );
  const [isAssetStsProbaReview, setAssetStsProbaReview] = useState(
    asset?.status === "Proba Review"
  );
  const [isAssetStsActive, setAssetStsActive] = useState(
    asset?.status === "Active"
  );
  const [isAssetStsValidatorReview, setAssetStsValidatorReview] = useState(
    asset?.status === "Validator Review"
  );

  const [
    isPerformOperationalCheckOnAsset,
    setIsPerformOperationalCheckOnAsset,
  ] = useState(false);
  const [isPerformValidationOnAsset, setIsPerformValidationOnAsset] = useState(
    false
  );

  const isValidatorAvailable = project?.assignment?.some(
    (obj) => obj.assignee_type === "Validator"
  );

  useEffect(() => {
    // checking asset has assignment verifier and is verfied.
    // And also wwhether asset is verified by verifier and validator or not
    if (asset?.assignment && asset?.assignment?.length) {
      let hasVerifier = false;
      let hasValidator = false;
      let isValidValidator = false;
      let hasVerifierVerified = false;
      let hasValidatorVerified = false;

      asset.assignment.forEach((assignee) => {
        if (assignee.assignee_type === "Verifier") {
          hasVerifier = true;
          if (assignee.verification_status === "verified") {
            hasVerifierVerified = true;
          }
        }
        if (assignee.assignee_type === "Validator") {
          hasValidator = true;
          if (assignee?.organization === orgId) {
            isValidValidator = true;
          }
          if (assignee.verification_status === "verified") {
            hasValidatorVerified = true;
          }
        }
      });

      setIsAssetHasAssignment({
        verifier: hasVerifier,
        isMatchingValidator: isValidValidator,
        validator: hasValidator,
      });

      setIsAssetVerified({
        verifier: hasVerifierVerified,
        validator: hasValidatorVerified,
      });
    } else {
      setIsAssetVerified(false);
      setIsAssetHasAssignment(false);
    }

    // checking project has assignment verifier and is verfied.
    // And also wwhether project is verified by verifier and validator or not
    if (project?.assignment && project?.assignment?.length) {
      let hasVerifier = false;
      let hasValidator = false;
      let hasProjectSponsor = false;

      let hasVerifierVerified = false;
      let hasValidatorVerified = false;

      project.assignment.forEach((assignee) => {
        if (assignee.assignee_type === "Verifier") {
          hasVerifier = true;
          if (assignee.verification_status === "verified") {
            hasVerifierVerified = true;
          }
        }
        if (assignee.assignee_type === "Validator") {
          hasValidator = true;
          if (assignee.verification_status === "verified") {
            hasValidatorVerified = true;
          }
        }
        if (assignee.assignee_type === "Project Sponsor") {
          hasProjectSponsor = true;
        }
      });

      setIsIntervHasAssignment({
        verifier: hasVerifier,
        validator: hasValidator,
        projectSponsor: hasProjectSponsor,
      });

      setIsInterventionVerified({
        verifier: hasVerifierVerified,
        validator: hasValidatorVerified,
      });
    } else {
      setIsInterventionVerified(false);
      setIsIntervHasAssignment(false);
    }
  }, [asset]);

  useEffect(() => {
    // Disable the submit to revision btn for Proba Operator after subit to revision
    if (project?.status == "Proba Review") {
      setIsProjectStsProbaReview(true);
    }

    // Disable the submit to revision btn for Proba Operator after subit to revision
    if (project?.status == "Revision") {
      setIsProjectStsRevision(true);
    }
  }, [project]);

  useEffect(() => {
    return () => {
      // Clean up the cache when component unmounts
      store.dispatch(validationApi.util.resetApiState());
    };
  }, []);

  const key = "updatable";
  const onEditRecord = (record) => {
    setEditingRecord({ ...record });
    setIsEditing(true);
  };

  const fetchValidationData = async () => {
    setIsValidationLoading(true);
    try {
      const { data: validationsData } = await store.dispatch(
        validationApi.endpoints.getValidation.initiate(project?._id, {
          forceRefetch: true,
        })
      );
      setValidationData(validationsData);
    } catch (error) {
      console.error("Error fetching validation data:", error);
      message.error("Failed to fetch validation data");
    } finally {
      setIsValidationLoading(false);
    }
  };

  const resetEditing = () => {
    setEditingRecord(null);
    setIsEditing(false);
    setIsCreate(false);
  };

  const closeModal = () => {
    //setEditParamRecord(null);
    setIsCreateParam(false);
    setIsEditParam(false);
  };

  const updateParam = (param) => {
    setEditParamRecord(param);
    setParamId(param._id);

    //Update the param id to methods
    if (editingRecord) {
      let editingRecordToUpdate = { ...editingRecord };
      editingRecordToUpdate.param_id = param ? param._id : null;
      handleEditRecord(editingRecordToUpdate);
      setEditingRecord(editingRecordToUpdate);
    }
  };

  const closeDocumentModal = () => {
    setIsCreateDocument(false);
    setIsEditDocument(false);
  };

  const updateDocument = (document) => {
    handleAddInterventionDocument(document);
  };

  const handleAddInterventionDocument = async (record) => {
    try {
      const body = {
        assetid: editingRecord?._id,
        requestbody: {
          document_id: record.document_id,
          asset_id: editingRecord?._id,
        },
      };

      await addAssetDocument(body)
        .unwrap()
        .then((res) => {
          message.success({
            content: "Asset Document added successfully!",
            key,
            duration: 2,
          });
          console.log(res);
        })
        .catch((err) => {
          message.error({
            content: "Failed to add Asset Doc!",
            key,
            duration: 2,
          });
          console.log(err);
        });
    } catch {}
  };

  const handleAddRecord = async (record) => {
    try {
      await addAsset(record)
        .unwrap()
        .then(async (res) => {
          message.success({
            content: "Asset added successfully!",
            key,
            duration: 2,
          });
          console.log(res);

          setIsEditing(true);
          setIsCreate(false);
          let currEditingRecord = { ...res?.data };
          onEditRecord(currEditingRecord);
          setParamId(res?.data?.param_id);
          dispatch(setAsset(currEditingRecord));
        })
        .catch((err) => {
          message.error({
            content: "Failed to add Asset: " + Object?.values(err["data"])[0],
            key,
            duration: 2,
          });
          console.log(err);
        });
    } catch {}
  };

  const handleEditRecord = async (record) => {
    try {
      const payload = {
        id: record.asset_id,
        body: record,
      };
      await updateAsset(payload)
        .unwrap()
        .then(async (res) => {
          message.success({
            content: "Asset updated successfully!",
            key,
            duration: 2,
          });
          let currEditingRecord = { ...res?.data };
          setEditingRecord({ ...currEditingRecord });
          setParamId(res?.data?.param_id);
          dispatch(setAsset(currEditingRecord));
        })
        .catch((err) => {
          message.error({
            content:
              "Failed to update Asset: " + Object?.values(err["data"])[0],
            key,
            duration: 2,
          });
          console.log(err);
        });
    } catch {}
  };

  const handleDeleteParam = async (id) => {
    try {
      await deleteParam(id)
        .unwrap()
        .then((res) => {
          message.success({
            content: "Param removed successfully!",
            key,
            duration: 2,
          });
          console.log(res);
        })
        .catch((err) => {
          message.error({
            content: "Failed to removed Param!",
            key,
            duration: 2,
          });
          console.log(err);
        });
    } catch {}
  };

  const [addAssignment] = useAddAssignmentMutation();

  const onCreate = async (values) => {
    try {
      setSpinning(true);
      const normalizedValues = normalizeAssetPayload(values);
      if (isEditing) {
        let assetToUpdate = { ...editingRecord };

        assetToUpdate.name = normalizedValues.name;
        assetToUpdate.project_id = normalizedValues.project_id;
        assetToUpdate.type = normalizedValues.type;
        assetToUpdate.plot_size = normalizedValues.plot_size;
        assetToUpdate.plot_size_unit = normalizedValues.plot_size_unit;
        assetToUpdate.soil = normalizedValues.soil;

        handleEditRecord(assetToUpdate);
        setEditingRecord(assetToUpdate);
      } else if (isCreate) {
        await handleAddRecord(normalizedValues);
        refetchValidation();
      }
    } catch {
    } finally {
      setSpinning(false);
    }
  };

  const [form] = Form.useForm();

  const onCancel = async () => {
    form.resetFields();
    let path = `/Asset`;
    history.push(path);
    onCancel();
  };
  const viewAssetRouteChange = () => {
    let path = `/intervention/view`;
    history.push(path);
  };

  const handleAddDocument = () => {
    setIsCreateDocument(true);
    setIsEditDocument(false);
    setEditDocumentRecord(null);
  };

  const handleAddParam = () => {
    setIsCreateParam(true);
    setIsEditParam(false);
    setEditParamRecord(null);
    setParamId(null);
  };

  const handleDispatchSubmitForProbaReview = (assetUpdateResponse) => {
    let assetRecord = { ...asset };
    assetRecord.status = assetUpdateResponse?.data?.status;
    dispatch(setAsset(assetRecord));
    setEditingRecord(assetRecord);

    setAssetStsProbaReview(true);
    setAddDocumentBtnDisabled(true);
    setAddParamBtnDisabled(true);
  };

  const handleAssetEditRecord = async (record) => {
    try {
      const payload = {
        id: record._id,
        body: record,
      };

      const res = await updateAssetStatus(payload)
        .unwrap()
        .then((res) => {
          message.success({
            content: "GHG Asset updated successfully!",
            key,
            duration: 2,
          });
          console.log(res);
          handleDispatchSubmitForProbaReview(res);
          setOpenProbaReviewModal(false);
          return res;
        })
        .catch((err) => {
          console.log("err", err);
          message.error({
            content:
              "Failed to update GHG Project: " + Object.values(err["data"])[0],
            key,
            duration: 6,
          });
          console.log(err);
        });
      return res;
    } catch {}
  };
  //bc-client
  const { onAccept: onAcceptCreateAssets } = useTransactionHandlers({
    actionname: createAssetsAction.name,
  });
  const createAssetsActionInBC = async (asset) => {
    return await onAcceptCreateAssets(asset);
  };
  //bc-client

  const handleOkOfProbaReviewModal = async () => {
    try {
      setSpinning(true);
      if (!usergroup.includes("Project Developer")) {
        message.error({
          content: "Action Prohibited",
          key,
          duration: 6,
        });
        return;
      } else if (!isIntervHasAssignment.validator) {
        message.error({
          content: "Assign the Validator for the Assets",
          key,
          duration: 6,
        });
        return;
      }

      const payload = {
        project: project,
        assets: [asset],
      };

      const result = await createAssetsActionInBC(payload);

      if (!result) {
        message.error({
          content: "Blockchain verification failed",
          key,
          duration: 6,
        });
        return;
      }

      const assetStatusUpdate = { ...asset };
      assetStatusUpdate["_ids"] = [assetStatusUpdate?.["_id"]];
      assetStatusUpdate["status"] = "Proba Review";
      const assetUpdateResponse = await handleAssetEditRecord(
        assetStatusUpdate
      );

      if (!assetUpdateResponse) {
        message.error({
          content: "Asset status update failed",
          key,
          duration: 6,
        });
        return;
      }
    } catch (error) {
      console.error(
        "Error calling blockchain function or updating asset:",
        error
      );
    } finally {
      setConfirmLoadingProbaReviewModal(false);
      setSpinning(false);
    }
  };

  const closeAssigneeToAssetModal = () => {
    setIsCreateAssigneeToAsset(false);
  };

  const closeSubmitForProbaReview = () => {
    setIsSubmitForProbaReview(false);
    setAssetStsProbaReview(false);
    setOpenProbaReviewModal(false);
  };

  const handleDispatchAfterAssignment = (assignmentResponse) => {
    const assigneeType = assignmentResponse?.assignee_type;
    let assetRecord = { ...asset };
    let assetRec_assignment_array = assetRecord?.assignment;

    const updateAssetRecord = () => {
      if (
        !Array.isArray(assetRec_assignment_array) ||
        assetRec_assignment_array === null
      ) {
        assetRecord.assignment = [assignmentResponse];
      } else {
        assetRecord.assignment = [
          ...assetRec_assignment_array,
          assignmentResponse,
        ];
      }
      dispatch(setAsset(assetRecord));
      setEditingRecord(assetRecord);
    };

    if (assigneeType === "Validator") {
      setIsAssetHasAssignment({
        verifier: true,
        validator: true,
      });
      updateAssetRecord();
    }

    if (assigneeType === "Verifier" || assigneeType === "Project Sponsor") {
      updateAssetRecord();
    }
  };

  const handleSubmitForProbaReview = async () => {
    await fetchValidationData();
    setOpenProbaReviewModal(true);
  };

  const handleAssignValidator = () => {
    setIsCreateAssigneeToAsset(true);
    setIsassignUserToAsset("Validator");
  };

  const ClosePerformOperationalCheckOnAssetModal = () => {
    setIsPerformOperationalCheckOnAsset(false);
    // setIntervStsValidatorReview(false)
  };

  const ClosePerformValidationOnAssetModal = () => {
    setIsPerformValidationOnAsset(false);
    // setIntervStsValidatorReview(false)
  };

  const handlePerformOperationalCheckOnAsset = () => {
    setIsPerformOperationalCheckOnAsset(true);
    // setIntervStsValidatorReview(true);
  };

  const handlePerformOValidationOnAsset = () => {
    setIsPerformValidationOnAsset(true);
    // setIntervStsValidatorReview(true);
  };

  const handleDispatchPerformOperationalCheck = (assetUpdateResponse) => {
    let assetRecord = { ...asset };
    assetRecord.status = assetUpdateResponse?.data?.status;
    dispatch(setAsset(assetRecord));
    setEditingRecord(assetRecord);

    let asset_sts = assetUpdateResponse?.data?.status;
    if (asset_sts === "Validator Review") {
      setAssetStsValidatorReview(true);
    } else if (asset_sts === "Active") {
      setAssetStsActive(true);
    } else if (asset_sts === "Revision") {
      setAssetStsRevision(true);
    }
    // setSubmitForProbaReviewBtnDisabled(true);
    // setAddDocumentBtnDisabled(true);
    // setAddParamBtnDisabled(true);
  };

  const renderAssetsPanelContent = () => {
    // Check for assets that require crops but don't have them
    const assetsWithoutRequiredCrops = validationData?.assets
      ?.filter(
        (item) =>
          !item?.has_crops &&
          item?.asset_id === asset?._id
      )
      ?.map((asset) => asset?.name);

    // Show error if any assets require crops but don't have them
    if (assetsWithoutRequiredCrops?.length > 0) {
      const errorMessage = `The following assets require at least one crop: ${assetsWithoutRequiredCrops.join(
        ", "
      )}`;
      return (
        <Alert
          message="Error"
          description={
            <Typography.Paragraph
              ellipsis={{ rows: 1, expandable: true, symbol: "more" }}
              style={{ maxHeight: "200px", overflowY: "auto" }}
            >
              {errorMessage}
            </Typography.Paragraph>
          }
          type="error"
          showIcon
        />
      );
    }

    // Return null if no crop validation errors
    return null;
  };

  const handleDispatchPerformValidationOnAsset = (assetUpdateResponse) => {
    let assetRecord = { ...asset };
    assetRecord.status = assetUpdateResponse?.data?.status;
    dispatch(setAsset(assetRecord));
    setEditingRecord(assetRecord);

    let asset_sts = assetUpdateResponse?.data?.status;
    if (asset_sts === "Revision") {
      setAssetStsRevision(true);
    } else if (asset_sts === "Active") {
      setAssetStsActive(true);
    }
  };

  const menu = (
    <Menu>
      {!isCreate &&
        usergroup.includes("Project Developer") &&
        project?.organization === orgId && (
          <>
            <Menu.Item key="submitForProbaReview">
              <Button
                type="link"
                onClick={handleSubmitForProbaReview}
                disabled={
                  !isIntervStsActive ||
                  isAssetStsProbaReview ||
                  isAssetStsValidatorReview ||
                  isAssetStsActive
                }
              >
                Submit for Proba Review
              </Button>
            </Menu.Item>
            <Menu.Item key="assignVerifierQuantity">
              <Button
                type="link"
                onClick={handleAssignValidator}
                disabled={
                  isCreate ||
                  isIntervHasAssignment.validator ||
                  isAssetHasAssignment.validator ||
                  !isValidatorAvailable
                }
              >
                Assign Validator
              </Button>
            </Menu.Item>
          </>
        )}
      {(usergroup.includes("Proba Operator") ||
        usergroup.includes("Verifier") ||
        usergroup.includes("Validator") ||
        usergroup.includes("Project Developer")) && (
        <Menu.Item key="addDocument">
          <Button
            type="link"
            onClick={handleAddDocument}
            disabled={
              isCreate || addDocumentBtnDisabled || isAssetStsProbaReview
            }
          >
            Add Document
          </Button>
        </Menu.Item>
      )}
      {!usergroup.includes("Verifier") && !usergroup.includes("Validator") && (
        <>
          {isCreate ? (
            <Menu.Item key="addParam">
              <Button
                type="link"
                onClick={handleAddParam}
                disabled={
                  isCreate ||
                  addParamBtnDisabled ||
                  isAssetStsProbaReview ||
                  isAssetStsActive
                }
              >
                Add Param
              </Button>
            </Menu.Item>
          ) : (
            <>
              {usergroup.includes("Project Developer") &&
                project?.organization === orgId && (
                  <>
                    {editingRecord && editingRecord?.param_id ? (
                      <>
                        <Menu.Item key="editParam">
                          <Button
                            disabled={isAssetStsProbaReview || isAssetStsActive}
                            type="link"
                            onClick={() => {
                              setIsCreateParam(false);
                              setIsEditParam(true);
                              setParamId(editingRecord?.param_id);
                            }}
                          >
                            Edit Param
                          </Button>
                        </Menu.Item>
                        <Menu.Item key="removeParam">
                          <Button
                            disabled={isAssetStsProbaReview || isAssetStsActive}
                            type="link"
                            onClick={() => {
                              setIsCreateParam(false);
                              setIsEditParam(false);
                              Modal.confirm({
                                title:
                                  "Are you sure you want to remove the Param?",
                                okText: "Yes",
                                okType: "danger",
                                onOk: () => {
                                  handleDeleteParam(editingRecord?.param_id);
                                  setEditParamRecord(null);
                                  setParamId(null);

                                  let recordToUpdate = { ...editingRecord };
                                  recordToUpdate.param_id = null;
                                  handleEditRecord(recordToUpdate);
                                  setEditingRecord(recordToUpdate);
                                },
                              });
                            }}
                          >
                            Remove Param
                          </Button>
                        </Menu.Item>
                      </>
                    ) : (
                      <Menu.Item key="addParam">
                        <Button
                          disabled={
                            isAssetStsProbaReview ||
                            isAssetStsActive ||
                            addParamBtnDisabled
                          }
                          type="link"
                          onClick={() => {
                            setIsCreateParam(true);
                            setIsEditParam(false);
                            setEditParamRecord(null);
                            setParamId(null);
                          }}
                        >
                          Add Param
                        </Button>
                      </Menu.Item>
                    )}
                  </>
                )}
            </>
          )}
        </>
      )}
      {usergroup.includes("Proba Operator") && (
        <Menu.Item key="AssetPerformOperationalCheck">
          <Button
            type="link"
            onClick={handlePerformOperationalCheckOnAsset}
            disabled={
              !isIntervStsActive ||
              isAssetStsValidatorReview ||
              isAssetStsActive ||
              isAssetStsRevision
            }
          >
            Perform Eligibility Check
          </Button>
        </Menu.Item>
      )}
      {usergroup.includes("Validator") && (
        <Menu.Item key="AssetPerformValidation">
          <Button
            type="link"
            onClick={handlePerformOValidationOnAsset}
            disabled={
              !isAssetHasAssignment.isMatchingValidator ||
              !isAssetStsValidatorReview ||
              isAssetStsRevision ||
              isAssetStsActive
            }
          >
            Perform Validation
          </Button>
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <>
      <Spin spinning={spinning}>
        <div style={{ height: "80vh" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Typography.Title level={2}>
              {isCreate
                ? "GHG Project (" + project?.name + ") : Add Asset"
                : isEditing
                ? "GHG Project (" +
                  project?.name +
                  ") : Edit Asset (" +
                  editingRecord?.name +
                  ")"
                : "GHG Project (" +
                  project?.name +
                  ") : View Asset (" +
                  editingRecord?.name +
                  ")"}
            </Typography.Title>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Dropdown overlay={menu} trigger={["hover"]}>
                <Button type="primary">
                  Actions <DownOutlined />
                </Button>
              </Dropdown>
              <Divider type="vertical"></Divider>
              <Button
                type="primary"
                onClick={() => {
                  viewAssetRouteChange();

                  //refetch the table
                  dispatch(assetApi.util.resetApiState());
                  dispatch(yieldApi.util.resetApiState());
                }}
              >
                Back
              </Button>
            </div>
          </div>

          <Divider type="vertical"></Divider>
          <div>
            <Row gutter={[10, 10]} align="stretch" style={{ display: "flex" }}>
              <Col span={12}>
                <Card
                  className="shadow-card"
                  style={{ height: "100%", borderRadius: 8, flexGrow: 1 }}
                >
                  <Typography.Title level={4}>Assets Details</Typography.Title>
                  <br></br>
                  {isEditing || isCreate ? (
                    <AssetForm
                      visible={isEditing || isCreate}
                      onCreate={onCreate}
                      onCancel={() => {
                        resetEditing();
                      }}
                      editingRecord={editingRecord}
                      editParamRecord={editParamRecord}
                      isCreateParam={isCreateParam}
                      isEditParam={isEditParam}
                      closeModal={closeModal}
                      updateParam={updateParam}
                      paramId={paramId}
                      editDocumentRecord={editDocumentRecord}
                      isCreateDocument={isCreateDocument}
                      isEditDocument={isEditDocument}
                      closeDocumentModal={closeDocumentModal}
                      updateDocument={updateDocument}
                      project={project}
                      isAssetHasAssignment={isAssetHasAssignment}
                      isPerformOperationalCheckOnAsset={
                        isPerformOperationalCheckOnAsset
                      }
                    />
                  ) : (
                    isView && (
                      <AssetView
                        onCreate={onCreate}
                        editingRecord={editingRecord}
                        editParamRecord={editParamRecord}
                        isCreateParam={isCreateParam}
                        isEditParam={isEditParam}
                        closeModal={closeModal}
                        updateParam={updateParam}
                        paramId={paramId}
                        editDocumentRecord={editDocumentRecord}
                        isCreateDocument={isCreateDocument}
                        isEditDocument={isEditDocument}
                        closeDocumentModal={closeDocumentModal}
                        updateDocument={updateDocument}
                        project={project}
                        isAssetFreeze={isAssetFreeze}
                        organizationData={organizationData}
                        usergroup={usergroup}
                        isPerformOperationalCheckOnAsset={
                          isPerformOperationalCheckOnAsset
                        }
                      />
                    )
                  )}
                </Card>
              </Col>
              <Col span={12}>
                <Card
                  className="shadow-card"
                  style={{ height: "100%", borderRadius: 8 }}
                >
                  <Typography.Title level={4}>Documents</Typography.Title>
                  <DisplayDocuments
                    id={editingRecord?._id}
                    entity="asset"
                  ></DisplayDocuments>
                </Card>
                {/* <Card className="shadow-card" style={{ height: "50%", borderRadius: 8, flexGrow: 1 }}>
                                <Typography.Title level={4}>Parameters</Typography.Title>
                                {editingRecord?.param_id != "" && <ParamView paramid={editingRecord?.param_id}></ParamView>}
                                </Card> */}
              </Col>
            </Row>

            <Row gutter={[10, 10]} style={{ marginTop: 10 }}>
              <Col span={24}>
                <Card className="shadow-card">
                  <Typography.Title level={4}>Parameters</Typography.Title>
                  {editingRecord?.param_id != "" && (
                    <ParamView paramid={editingRecord?.param_id}></ParamView>
                  )}
                </Card>
              </Col>
            </Row>


            <Row gutter={[10, 10]} style={{ marginTop: 10 }}>
              <Col span={24}>
                <Card className="shadow-card">
                  {editingRecord?._id != "" && editingRecord?._id && (
                    <Yield
                      assetid={editingRecord?._id}
                      setSpinning={setSpinning}
                      intervassignment={project?.assignment}
                    ></Yield>
                  )}
                </Card>
              </Col>
            </Row>
          </div>
          <Params
            paramId={paramId}
            updateParam={updateParam}
            isCreate={isCreateParam}
            isEditing={isEditParam}
            closeModal={closeModal}
          />
          <AddDocument
            ids={[editingRecord?._id]}
            entity="asset"
            updateDocument={updateDocument}
            editingRecord={editDocumentRecord}
            isCreate={isCreateDocument}
            isEditings={isEditDocument}
            closeModal={closeDocumentModal}
          />
          <AssignVerifier
            isCreate={isCreateAssigneeToAsset}
            groupname={isassignUserToAsset}
            isDetails={asset}
            closeModal={closeAssigneeToAssetModal}
            assignmentTo={"GHG Asset"}
            handleDispatchAfterAssignment={handleDispatchAfterAssignment}
            refetchValidation={refetchValidation}
          />
          <PerformOperationaCheckOnAsset
            assetDetails={asset}
            usergroup={usergroup}
            isCreate={isPerformOperationalCheckOnAsset}
            closeModal={ClosePerformOperationalCheckOnAssetModal}
            handleDispatchPerformOperationalCheck={
              handleDispatchPerformOperationalCheck
            }
          />
          <PerformValidationOnAsset
            assetDetails={asset}
            updateDocument={updateDocument}
            setSpinning={setSpinning}
            spinning={spinning}
            usergroup={usergroup}
            isCreate={isPerformValidationOnAsset}
            closeModal={ClosePerformValidationOnAssetModal}
            handleDispatchPerformValidationOnAsset={
              handleDispatchPerformValidationOnAsset
            }
          />
        </div>
      </Spin>
      <Modal
        title="Submit for Proba Review"
        visible={openProbaReviewModal}
        onOk={handleOkOfProbaReviewModal}
        okText="Submit for Proba Review"
        confirmLoading={confirmLoadingProbaReviewModal || spinning}
        onCancel={() => {
          if (!(confirmLoadingProbaReviewModal || spinning))
            closeSubmitForProbaReview();
        }}
        okButtonProps={{
          disabled: !!renderAssetsPanelContent() || isValidationLoading,
        }}
      >
        <Spin spinning={isValidationLoading} tip="Validating assets...">
          <p>Are you sure you want to submit assets for Proba Review?</p>
          {renderAssetsPanelContent() && (
            <Collapse defaultActiveKey={["project", "assets", "yield"]}>
              <Collapse.Panel
                header={
                  <Space>
                    <Typography.Text strong>Errors in Assets</Typography.Text>
                    {renderAssetsPanelContent() === null ? (
                      <CheckCircleTwoTone twoToneColor="#52c41a" />
                    ) : (
                      <CloseCircleTwoTone twoToneColor="#eb2f96" />
                    )}
                  </Space>
                }
                key="assets"
              >
                {renderAssetsPanelContent()}
              </Collapse.Panel>
            </Collapse>
          )}
        </Spin>
      </Modal>
    </>
  );
}

const AssetForm = ({
  onCreate,
  editingRecord,
  project,
  isAssetHasAssignment,
}) => {
  const { data = [], isLoading } = useGetProjectQuery();
  const intervention_children = [];
  if (!isLoading) {
    data?.data?.forEach((project) => {
      intervention_children.push(
        <Select.Option key={project._id}>{project.name}</Select.Option>
      );
    });
  }

  const { TextArea } = Input;
  const [form] = Form.useForm();
  const assetType = Form.useWatch("type", form) || DEFAULT_ASSET_TYPE;
  const isLmuType = assetType === "land_management_unit";
  const assignmentState = isAssetHasAssignment || {};
  const disableSubmit =
    (assignmentState.verifier || assignmentState.validator) &&
    !(
      editingRecord?.status === "Revision" ||
      editingRecord?.status === "New"
    );

  useEffect(() => {
    form.setFieldsValue({
      ...editingRecord,
      type: editingRecord?.type || DEFAULT_ASSET_TYPE,
    });
  }, [editingRecord, form]);

  return (
    <>
      <Form
        layout="vertical"
        form={form}
        name="asset"
        initialValues={{
          ...editingRecord,
          type: editingRecord?.type || DEFAULT_ASSET_TYPE,
        }}
        onFinish={onCreate}
        autoComplete="off"
      >
        <Row gutter={[20, 0]}>
          <Col span={8}>
            <Form.Item
              name="name"
              label="Asset Name"
              rules={[
                {
                  required: true,
                  message: "Please input Asset name!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="project_id"
              label="GHG Project"
              rules={[
                {
                  required: true,
                  message: "Please select the GHG Project",
                },
              ]}
              initialValue={project?._id}
            >
              <Select
                style={{
                  width: "100%",
                }}
                placeholder="Please select the GHG Project"
                disabled={true}
              >
                {intervention_children}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="type"
              label="Asset Type"
              rules={[
                {
                  required: true,
                  message: "Please select an asset type",
                },
              ]}
            >
              <Select placeholder="Select asset type">
                {ASSET_TYPE_OPTIONS.map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        {isLmuType && (
          <Row gutter={[20, 0]}>
            <Col span={8}>
              <Form.Item
                name="plot_size"
                label="Area"
                rules={[
                  {
                    required: true,
                    message: "Area is required for LMU assets",
                  },
                ]}
              >
                <InputNumber
                  min={0}
                  style={{ width: "100%" }}
                  placeholder="Enter area"
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="plot_size_unit"
                label="Area Unit"
                rules={[
                  {
                    required: true,
                    message: "Please select an area unit",
                  },
                ]}
                initialValue="ha"
              >
                <Select placeholder="Select unit">
                  {PLOT_SIZE_UNIT_OPTIONS.map((unit) => (
                    <Select.Option key={unit.value} value={unit.value}>
                      {unit.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="soil" label="Soil (optional)">
                <Input placeholder="Enter soil type or leave blank" />
              </Form.Item>
            </Col>
          </Row>
        )}

        <Form.Item name="_id" label="Asset ID" hidden>
          <Input />
        </Form.Item>
        <Form.Item name="project_id" label="GHG Project ID" hidden>
          <Input />
        </Form.Item>
        <Form.Item>
          <Button disabled={disableSubmit} type="primary" htmlType="submit">
            Submit Asset
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

const AssetView = ({
  editingRecord,
  isAssetFreeze,
  organizationData,
  usergroup,
}) => {
  const { data: assetparam, isLoading: isParamLoading } = useGetParamQuery(
    editingRecord?.param_id,
    {
      skip: !editingRecord?.param_id,
    }
  );

  const [isShowCertificate, setIsShowCertificate] = useState(false);

  const closeCertificateModal = () => {
    setIsShowCertificate(false);
  };

  const paramDescriptions = [];
  if (!isParamLoading) {
    //TODO - It should only return an object not an array
    const paramsarray = assetparam
      ? assetparam?.length > 0
        ? assetparam[0]?.param
        : []
      : [];
    paramsarray?.forEach((param) => {
      paramDescriptions.push(
        <Descriptions.Item
          label={<Typography.Text strong>{param.key}</Typography.Text>}
          span={1}
        >
          {param.value}
        </Descriptions.Item>
      );
    });
  }

  const { data = [], isLoading } = useGetProjectQuery();
  const intervention_children = [];
  if (!isLoading) {
    data?.data?.forEach((project) => {
      intervention_children.push(
        <Select.Option key={project._id}>{project.name}</Select.Option>
      );
    });
  }

  const { TextArea } = Input;

  const [form] = Form.useForm();

  const format = (value) => (
    <Typography.Text style={{ fontSize: 18, overflowWrap: "anywhere" }}>
      {value === true ? "Yes" : value === false ? "No" : value}
    </Typography.Text>
  );

  const assetTypeValue = editingRecord?.type || DEFAULT_ASSET_TYPE;
  const assetTypeLabel =
    ASSET_TYPE_OPTIONS.find(({ value }) => value === assetTypeValue)?.label ||
    assetTypeValue;
  const isLmuAsset = assetTypeValue === "land_management_unit";

  return (
    <>
      <Row gutter={[100, 20]}>
        <Col span={8}>
          <Statistic
            title="Asset Name"
            value={editingRecord?.name}
            formatter={(value) => format(value)}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title="External Asset Id"
            value={editingRecord?.external_asset_id}
            formatter={(value) => format(value)}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title="Organization"
            value={organizationData?.name}
            formatter={(value) => format(value)}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title="GHG Project"
            value={editingRecord?.project_id}
            formatter={(value) => (
              <DisplayIntervention interventionid={value}></DisplayIntervention>
            )}
          />
        </Col>
       
        <Col span={8}>
          <Statistic
            title="Status"
            value={
              statusOptions?.find(
                ({ value }) => value === editingRecord?.status
              )?.label
            }
            formatter={(value) => format(value)}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title="Asset Type"
            value={assetTypeLabel}
            formatter={(value) => format(value)}
          />
        </Col>
        {isLmuAsset && (
          <>
            <Col span={8}>
              <Statistic
                title="Area"
                value={editingRecord?.plot_size}
                formatter={(value) => format(value)}
              />
            </Col>
            <Col span={8}>
              <Statistic
                title="Area Unit"
                value={editingRecord?.plot_size_unit || "ha"}
                formatter={(value) => format(value)}
              />
            </Col>
            <Col span={8}>
              <Statistic
                title="Soil"
                value={editingRecord?.soil}
                formatter={(value) => format(value)}
              />
            </Col>
          </>
        )}
        <Col span={8}>
          <Statistic
            title="Assignees"
            value={editingRecord?.assignment}
            formatter={(value) => {
              let validator_org_id, project_sponsor_org_id;
              if (Array.isArray(value)) {
                value.map((assignment) => {
                  if (assignment.assignee_type === "Validator") {
                    validator_org_id = assignment?.organization;
                  }
                  if (assignment.assignee_type === "Project Sponsor") {
                    project_sponsor_org_id = assignment?.organization;
                  }
                });
                return (
                  <Popover
                    content={
                      <>
                        <Typography.Text strong>Validator:</Typography.Text>
                        <DisplayOrganization
                          orgid={validator_org_id}
                          place="table"
                        />
                        <Typography.Text strong>
                          Project Sponsor:
                        </Typography.Text>
                        <DisplayOrganization
                          orgid={project_sponsor_org_id}
                          place="table"
                        />
                      </>
                    }
                  >
                    <ContactsOutlined />
                  </Popover>
                );
              } else {
                return (
                  <Popover content={<></>}>
                    <ContactsOutlined />
                  </Popover>
                );
              }
            }}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title="Creator"
            value={editingRecord?.creator}
            formatter={(value) => (
              <DisplayUserName userid={value}></DisplayUserName>
            )}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title="Updator"
            value={editingRecord?.updator}
            formatter={(value) => (
              <DisplayUserName userid={value}></DisplayUserName>
            )}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title="Created At"
            value={editingRecord?.created}
            formatter={(value) => (
              <DisplayDateTime date_time={value}></DisplayDateTime>
            )}
          />
        </Col>
        <Col span={8}>
          <Statistic
            title="Updated At"
            value={editingRecord?.updated}
            formatter={(value) => (
              <DisplayDateTime date_time={value}></DisplayDateTime>
            )}
          />
        </Col>
        {editingRecord?.is_updated_to_blockchain === true && (
          <Col span={8}>
            <Statistic
              title="Is Updated to Blockchain? "
              value={editingRecord?.is_updated_to_blockchain}
              formatter={(value) => format(value)}
            />
          </Col>
        )}
      </Row>

      <ViewDownloadCertificate
        isShowCertificate={isShowCertificate}
        assetrecord={editingRecord}
        closeModal={closeCertificateModal}
      />
    </>
  );
};

export default AddEditAsset;
